import React, { useEffect, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MuiFab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';

import EnhancedTable from 'components/EnhancedTable';
import { getPrintFields } from 'modules/customer';

const Fab = styled(MuiFab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(2),
  right: theme.spacing(2),
  zIndex: 2,
}));

function SettingCustomerPrint() {
  const { formatMessage } = useIntl()
  const config = useSelector(state => state.config.data)
  const userRights = useSelector(state => state.userRights)
  const extDataMapping = useSelector(state => state.customerExtTab.data)
  const [printFields, setPrintFields] = useState({ basic: [],ice: [],ext: [] })

  useEffect(() => {
    if (extDataMapping) {
      setPrintFields( data => {
        return getPrintFields(extDataMapping, config.customerExtTab, config.printCustomerData)
      })
    }
    return () => {}
  }, [extDataMapping]);

  const tableCells = ['printField', 'fieldSize']

  const formatData = (field) => {
    const newData = { ...field }
    newData.status = newData.active ? '啟用' : '停用'

    newData.printField = field.ext ? field.name : field.roots ? formatMessage({ id: `customer.profile.${field.name}.roots` }) : formatMessage({ id: `customer.profile.${field.name}` })
    newData.fieldSize = field.size

    return newData
  }

  const headerCells = tableCells.reduce((acc, cur) => {
    acc.push({ text: cur, align: 'left' })

    return acc
  }, []).concat({ text: 'status', align: 'right' }).map(c => { c.text = formatMessage({ id: `setCustomer.print.table.header.${c.text}` }); return c })

  const rowCells = tableCells.reduce((acc, cur) => {
    acc.push({ field: cur, align: 'left' })
    return acc
  }, []).concat({ field: 'status', align: 'right' })


  return (
    <Box style={{ marginTop: '20px', display: 'flex', gap: '8px', flexDirection: 'column' }}>
      {userRights.hasUserRight('setting-edit') &&
        <Link to={'/setting/customer/print/edit'}>
          <Fab color="primary">
            <EditIcon />
          </Fab>
        </Link>
      }
      <div>
        <Typography color="textSecondary" variant="button"><FormattedMessage id="customer.profile.basic" /></Typography>
        <EnhancedTable
          defaultOrder="asc"
          defaultOrderField="code"
          headerCells={headerCells}
          rowCells={rowCells}
          tableData={printFields.basic.map(i => formatData(i))}
        />
      </div>
      <div>
        <Typography color="textSecondary" variant="button"><FormattedMessage id="customer.profile.emergencyContacts.root" /></Typography>
        <EnhancedTable
          defaultOrder="asc"
          defaultOrderField="code"
          headerCells={headerCells}
          rowCells={rowCells}
          tableData={printFields.ice.map(i => formatData(i))}
        />
      </div>
      {printFields.ext.filter(i => i.fields.filter(j => j.active).length > 0).map( i => (
        <div key={i.id}>
          <Typography color="textSecondary" variant="caption">{i.name}</Typography>
          <EnhancedTable
            defaultOrder="asc"
            defaultOrderField="code"
            headerCells={headerCells}
            rowCells={rowCells}
            tableData={i.fields.map(i => formatData(i))}
          />
        </div>
      ))}
    </Box>
  );
}

export default SettingCustomerPrint;
